webpackJsonp([186],{

/***/ 1001:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AudioAsrCheckTemplateTable_vue__ = __webpack_require__(2513);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03627038_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AudioAsrCheckTemplateTable_vue__ = __webpack_require__(3172);
function injectStyle (ssrContext) {
  __webpack_require__(3164)
  __webpack_require__(3166)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-03627038"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AudioAsrCheckTemplateTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03627038_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AudioAsrCheckTemplateTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1346:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export removeDefaultParams */
/* unused harmony export trimParams */
/* harmony export (immutable) */ __webpack_exports__["c"] = removeEmptyParams;
/* harmony export (immutable) */ __webpack_exports__["d"] = setParams;
/* unused harmony export setDefaultParams */
/* unused harmony export conveDataType */
/* harmony export (immutable) */ __webpack_exports__["a"] = conveSomeDataType;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);


/*
 * 表格页面的通用方法
 * @Author: anker.wang
 * @Date: 2018-01-08 11:25:59
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-06-27 12:12:26
 * @Description 路由参数自动同步到搜索参数;在路由更新时获得表格数据;使用分页和搜索事件自动变更路由
 */



/* harmony default export */ __webpack_exports__["b"] = ({
  data: function data() {
    return {
      // 搜索表单字段
      search: {},
      // 搜索字段申明
      searchFieldType: {},
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0
      },
      refSearchForm: 'searchForm',
      lastSeachParams: {},
      isLoadTableInBeforeRouteEnter: true,
      isLoadTableInBeforeRouteUpdate: true
    };
  },

  // 路由进入时
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    // 在导航转入新的路由前
    next(function (vm) {
      if (vm.isLoadTableInBeforeRouteEnter) {
        // 处理路由参数
        var queryParams = vm.getRouterQueryParams(to.query);
        // 设置搜索参数
        vm.setSearchParams(queryParams);
        // 加载表格数据
        vm.loadTableData(queryParams);
      }
    });
  },

  // 路由更新时
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    if (this.isLoadTableInBeforeRouteUpdate) {
      // 处理路由参数
      var queryParams = this.getRouterQueryParams(to.query);
      // 加载表格数据
      this.loadTableData(queryParams);
    }
    // 继续加载路由
    next();
  },

  methods: {
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData: function getTableData(params) {},

    /**
     * 设置表格数据
     * @param {*} params
     */
    setTableData: function setTableData(_ref) {
      var data = _ref.data;

      this.$set(this, 'table', data.data);
      this.setPagination(data);
    },

    /**
     * 获得搜索参数
     */
    getSearchParams: function getSearchParams() {
      return this.search;
    },

    /**
     * 设置搜索参数
     */
    setSearchParams: function setSearchParams(params) {
      setParams(this.search, params);
    },

    /**
     * 获得搜索参数的类型声明
     * @description 从路由上同步参数时会造成获得全部都是字符串
     */
    getSearchFieldType: function getSearchFieldType() {
      return this.searchFieldType;
    },

    /**
     * 获取分页数据
     */
    getPagination: function getPagination() {
      return {
        current_page: this.pagination.current_page,
        per_page: this.pagination.per_page
      };
    },

    /**
     * 设置分页数据
     * @pagination {current_page, per_page, total}
     */
    setPagination: function setPagination(pagination) {
      // 转换数据类型
      pagination = conveSomeDataType(pagination, this.pagination);
      // 设置参数
      setParams(this.pagination, pagination);
    },

    /**
     * 处理分页大小时的变化
     * @param {*} val
     */
    handleSizePageChange: function handleSizePageChange(val) {
      this.setPagination({ per_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 处理页码变化
     * @param {*} val
     */
    handleCurrentPageChange: function handleCurrentPageChange(val) {
      this.setPagination({ current_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 获得路由参数
     * 必须 search 中存在的字段，通过申明的类型转换
     * @param {*} query
     */
    getRouterQueryParams: function getRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$route.query;

      // 删除标识路由更新的空名字段
      if (query.hasOwnProperty('')) {
        delete query[''];
      }
      // 获得参数默认值

      var _$options$data$call = this.$options.data.call(this),
          pagination = _$options$data$call.pagination,
          search = _$options$data$call.search;

      return conveSomeDataType(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination), this.getSearchFieldType());
    },

    /**
     * 设置路由参数
     * @description 设置路由参数
     */
    setRouterQueryParams: function setRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _$options$data$call2 = this.$options.data.call(this),
          pagination = _$options$data$call2.pagination,
          search = _$options$data$call2.search;

      this.$router.replace({
        query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, removeEmptyParams(trimParams(removeDefaultParams(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination)))), {
          // 用于相同的搜索参数时也触发路由更新
          '': __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('HHmmssSS')
        })
      });
    },

    /**
     * 加载表格数据
     * @param {*} params
     */
    loadTableData: function loadTableData(params) {
      // 移除空的参数
      params = removeEmptyParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getSearchParams(), params));
      // 设置默认分页大小值

      var _$options$data$call3 = this.$options.data.call(this),
          pagination = _$options$data$call3.pagination;

      params = setDefaultParams(params, {
        current_page: pagination.current_page,
        per_page: pagination.per_page
      });
      // 保存本次请求参数
      this.lastSeachParams = params;
      // 获得表格数据
      this.getTableData(params).then(this.setTableData);
    },

    /**
     * 刷新当前页的表格数据
     */
    onRefresh: function onRefresh() {
      // 根据上次请求数据再次获取
      return this.getTableData(this.lastSeachParams).then(this.setTableData);
    },

    /**
     * 搜索列表方法
     * @param {*} params
     */
    onSearch: function onSearch(params) {
      var _this = this;

      var search = function search() {
        _this.setPagination({ current_page: 1 });
        _this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.getPagination(), _this.getSearchParams(), params));
      };
      // 验证填写参数
      var searchForm = this.$refs[this.refSearchForm];
      if (searchForm) {
        searchForm.validate(function (valid) {
          if (valid) {
            search();
          } else {
            _this.$message.error('搜索内容填写不正确！');
          }
        });
      } else {
        search();
      }
    },

    /**
     * 重置表单方法
     */
    resetSearch: function resetSearch() {
      this.$refs[this.refSearchForm].resetFields();
    }
  }

  /**
   * 移除参数中的默认参数
   * @param params
   * @param defaultParams
   * @returns {*}
   */
});function removeDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && params.hasOwnProperty(key)) {
      if (_.isEqual(defaultParams[key], params[key])) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 移除参数中字符串的前后空格
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function trimParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && typeof params[key] === 'string') {
      params[key] = params[key].trim();
    }
  }
  return params;
}

/**
 * 删除空的参数
 * @param params
 * @returns {*}
 */
function removeEmptyParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key)) {
      // 为数组时必须长度大于0
      if (params[key] instanceof Array && params[key].length === 0) {
        delete params[key];
      }
      // 空字符串或者null时删除字段
      if (params[key] === '' || params[key] === null) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 设置数据
 * @param params
 * @param newParams
 * @returns {*}
 */
function setParams(params, newParams) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && newParams.hasOwnProperty(key)) {
      params[key] = newParams[key];
    }
  }
  return params;
}

/**
 * 设置默认参数
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function setDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && !params.hasOwnProperty(key)) {
      params[key] = defaultParams[key];
    }
  }
  return params;
}

/**
 * 数据类型转换
 * @param value
 * @param type
 */
function conveDataType(value, type) {
  // 类型相同不用转换
  if (value.constructor !== type) {
    // 实际类型为对象时进入内部
    if (type.constructor === Object && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(type).length > 0) {
      for (var key in value) {
        if (value.hasOwnProperty(key)) {
          // 声明为对象时逐个转换
          value[key] = conveDataType(value[key], type[key]);
        }
      }
    } else {
      value = type(value);
    }
  }
  return value;
}

/**
 * 转换一些数据类型
 * @param params
 * @param defaultParams
 * @param types
 * @returns {*}
 * @description
 * types = {
 *   count: Number,
 *   object: {
 *     id: Number,
 *     date: Date
 *   },
 *   array: {
 *     0: Number,
 *     1: Boolean
 *   },
 * }
 */
function conveSomeDataType(params, defaultParams, types) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && params[key] !== null && params[key] !== undefined && defaultParams.hasOwnProperty(key)) {
      // 存在数据声明
      if (types && types.hasOwnProperty(key)) {
        params[key] = conveDataType(params[key], types[key]);
      } else if (defaultParams[key] !== null && defaultParams[key] !== undefined) {
        // 不存在获取默认参数的数据原类型
        var paramType = defaultParams[key].constructor;
        // 只对非对象数组的参数进行转换
        if (paramType !== Object) {
          params[key] = conveDataType(params[key], paramType);
        }
      }
    }
  }
  return params;
}

/***/ }),

/***/ 1347:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
 * ElementUI 日期选择组件的参数
 * @Author: anker.wang
 * @Date: 2018-01-08 11:27:07
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-01-08 11:28:27
 */

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      dateTimePickerOptions: {
        shortcuts: [{
          text: '一周后',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }, {
          text: '三天后',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 3);
            picker.$emit('pick', date);
          }
        }, {
          text: '明天',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '今天',
          onClick: function onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '三天前',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 3);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
      dateTimePickerRangeOptions: {
        shortcuts: [{
          text: '最近1周',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近1个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近3个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近6个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近1年',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近2年',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 730);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近3年',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 1095);
            picker.$emit('pick', [start, end]);
          }
        }]
      }
    };
  }
});

/***/ }),

/***/ 2513:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_mixins_table__ = __webpack_require__(1346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_mixins_dateTimePicker__ = __webpack_require__(1347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AudioAsrCheckBoundSubstepDialog__ = __webpack_require__(3168);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { AudioAsrCheckBoundSubstepDialog: __WEBPACK_IMPORTED_MODULE_3__components_AudioAsrCheckBoundSubstepDialog__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__core_mixins_table__["b" /* default */], __WEBPACK_IMPORTED_MODULE_2__core_mixins_dateTimePicker__["a" /* default */]],
  data: function data() {
    return {
      searchExpanded: true,
      listExpanded: true,
      search: {
        title: null,
        creator_id: null,
        created_at: []
      },
      table: [],
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0
      },
      searchFieldType: {
        creator_id: Number,
        created_at: Array
      },
      boundSubstepDialogVisible: false,
      boundSubstepTemplateId: null,
      boundSubstepTemplateTitle: ''
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, request.map(['getBasicPlatformUsersIndex', 'getPlatformUsersDetail']), {
    getTableData: function getTableData(params) {
      return request.page('queryAudioAsrCheckTemplate', params);
    },
    onExportSearch: function onExportSearch() {
      var exportParams = Object(__WEBPACK_IMPORTED_MODULE_1__core_mixins_table__["c" /* removeEmptyParams */])(_.cloneDeep(this.lastSeachParams || {}));
      delete exportParams.current_page;
      delete exportParams.per_page;
      delete exportParams[''];
      this.$export(this.$route.meta.title + '_\u641C\u7D22\u7ED3\u679C', {
        fileHeader: [{ key: 'id', text: '配置ID' }, { key: 'title', text: '配置标题' }, { key: 'question_count', text: '问题数' }, { key: 'bind_count', text: '绑定分步模板数' }, { key: 'user_name', text: '创建人' }, { key: 'created_at', text: '创建时间' }, { key: 'updated_at', text: '更新时间' }],
        total: this.pagination.total,
        request: this.getTableData,
        requestParams: exportParams
      });
    },
    resetSearch: function resetSearch() {
      this.$refs[this.refSearchForm].resetFields();
      this.onSearch();
    },
    canDelete: function canDelete(row) {
      return Number(row.editable) === 1 && Number(row.bind_count) === 0;
    },
    onCopy: function onCopy(row) {
      var _this = this;

      this.$confirm('\u786E\u8BA4\u590D\u5236\u914D\u7F6E\u300C' + row.title + '\u300D\u5417\uFF1F\u5C06\u751F\u6210\u4E00\u4EFD\u65B0\u914D\u7F6E\uFF08\u4E0D\u542B\u5206\u6B65\u6A21\u677F\u7ED1\u5B9A\uFF09\u3002', '提示', { type: 'info' }).then(function () {
        request.common('copyAudioAsrCheckTemplate', row.id).then(function () {
          _this.$message.success('复制成功');
          _this.onRefresh();
        });
      }).catch(function () {});
    },
    onDelete: function onDelete(row) {
      var _this2 = this;

      this.$confirm('\u786E\u8BA4\u5220\u9664\u914D\u7F6E\u300C' + row.title + '\u300D\u5417\uFF1F\u5220\u9664\u540E\u65E0\u6CD5\u6062\u590D\u3002', '提示', { type: 'warning' }).then(function () {
        request.common('deleteAudioAsrCheckTemplate', row.id).then(function () {
          _this2.$message.success('删除成功');
          _this2.onRefresh();
        });
      }).catch(function () {});
    },
    openBoundSubstepDialog: function openBoundSubstepDialog(row) {
      this.boundSubstepTemplateId = row.id;
      this.boundSubstepTemplateTitle = row.title || '';
      this.boundSubstepDialogVisible = true;
    }
  })
});

/***/ }),

/***/ 2514:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AudioAsrCheckBoundSubstepDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    templateId: {
      type: [Number, String],
      default: null
    },
    templateTitle: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      loading: false,
      list: [],
      addSubstepId: null,
      adding: false,
      unbindingId: null,
      dirty: false
    };
  },

  computed: {
    dialogVisible: {
      get: function get() {
        return this.visible;
      },
      set: function set(value) {
        this.$emit('update:visible', value);
      }
    },
    dialogTitle: function dialogTitle() {
      var title = this.templateTitle || '';
      var id = this.templateId;
      if (title && id) {
        return '\u7BA1\u7406\u5173\u8054\u5206\u6B65\u6A21\u677F\uFF08' + title + ' / ' + id + '\uFF09';
      }
      return '管理关联分步模板';
    },
    boundIdSet: function boundIdSet() {
      var set = {};
      this.list.forEach(function (item) {
        set[Number(item.id)] = true;
      });
      return set;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, request.map(['getStepTemplateTable', 'getStepTemplateDetail']), {
    onOpen: function onOpen() {
      this.dirty = false;
      this.addSubstepId = null;
      this.loadList();
    },
    onClose: function onClose() {
      this.list = [];
      this.addSubstepId = null;
      this.adding = false;
      this.unbindingId = null;
      if (this.dirty) {
        this.$emit('changed');
        this.dirty = false;
      }
    },
    loadList: function loadList() {
      var _this = this;

      if (!this.templateId) {
        this.list = [];
        return;
      }
      this.loading = true;
      request.common('listAudioAsrCheckBindByTemplate', { id: this.templateId }).then(function (_ref) {
        var data = _ref.data;

        _this.list = data && data.data ? data.data : [];
      }).catch(function () {
        _this.list = [];
      }).finally(function () {
        _this.loading = false;
      });
    },
    formatTitleWithId: function formatTitleWithId(item) {
      var title = item.title == null || item.title === '' ? '' : String(item.title);
      var id = item.id == null || Number(item.id) === 0 ? '' : String(item.id);
      if (title && id) {
        return title + ' / ' + id;
      }
      return title || id || '-';
    },
    stepTemplatePath: function stepTemplatePath(item) {
      var id = item.id;
      if (Number(item.type) === 20) {
        return '/clb-step-template/update/' + id;
      }
      return '/step-template/update/' + id;
    },
    onUnbind: function onUnbind(item) {
      var _this2 = this;

      var label = this.formatTitleWithId(item);
      this.$confirm('\u786E\u8BA4\u53BB\u6389\u4E0E\u300C' + label + '\u300D\u7684\u5173\u8054\u5417\uFF1F', '提示', { type: 'warning' }).then(function () {
        _this2.unbindingId = item.id;
        request.common('unbindAudioAsrCheckTemplate', item.id).then(function () {
          _this2.$message.success('已去掉关联');
          _this2.dirty = true;
          _this2.loadList();
        }).finally(function () {
          _this2.unbindingId = null;
        });
      }).catch(function () {});
    },
    onAdd: function onAdd() {
      var _this3 = this;

      var substepId = Number(this.addSubstepId);
      if (!substepId || !this.templateId) {
        return;
      }
      if (this.boundIdSet[substepId]) {
        this.$message.warning('该分步模板已关联当前配置');
        return;
      }

      this.adding = true;
      request.common('getAudioAsrCheckBindBySubstep', { substepid: substepId }).then(function (_ref2) {
        var data = _ref2.data;

        var boundTemplateId = data && data.audio_asr_check_template_id ? Number(data.audio_asr_check_template_id) : 0;
        if (boundTemplateId > 0 && boundTemplateId !== Number(_this3.templateId)) {
          var boundTitle = data.template && data.template.title ? data.template.title : '';
          var boundLabel = boundTitle ? boundTitle + ' / ' + boundTemplateId : String(boundTemplateId);
          return _this3.$confirm('\u8BE5\u5206\u6B65\u6A21\u677F\u5DF2\u5173\u8054\u914D\u7F6E\u300C' + boundLabel + '\u300D\uFF0C\u786E\u8BA4\u6362\u7ED1\u5230\u5F53\u524D\u914D\u7F6E\u5417\uFF1F', '提示', { type: 'warning' }).then(function () {
            return _this3.doBind(substepId);
          });
        }
        return _this3.doBind(substepId);
      }).catch(function () {}).finally(function () {
        _this3.adding = false;
      });
    },
    doBind: function doBind(substepId) {
      var _this4 = this;

      return request.common('bindAudioAsrCheckTemplate', {
        substepid: substepId,
        audio_asr_check_template_id: this.templateId
      }).then(function () {
        _this4.$message.success('关联成功');
        _this4.addSubstepId = null;
        _this4.dirty = true;
        _this4.loadList();
      });
    }
  })
});

/***/ }),

/***/ 3164:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3165);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("066bbfd0", content, true, {});

/***/ }),

/***/ 3165:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".asr-check-template-table__card[data-v-03627038]{background:#fff;border-radius:8px;-webkit-box-shadow:0 1px 3px rgba(0,0,0,.08);box-shadow:0 1px 3px rgba(0,0,0,.08);overflow:hidden}.asr-check-template-table__card+.asr-check-template-table__card[data-v-03627038]{margin-top:16px}.asr-check-template-table__card-header[data-v-03627038]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:12px 24px;border-bottom:1px solid #ebeef5;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;color:#606266;font-size:14px;font-weight:500}.asr-check-template-table__card-header i[data-v-03627038]{color:#909399}.asr-check-template-table__card-header-actions[data-v-03627038]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px}.asr-check-template-table__card-header-actions ::v-deep .asr-check-template-table__header-action.el-button[data-v-03627038]{min-width:24px;padding:0;margin:0}.asr-check-template-table__header-action[data-v-03627038]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:24px;height:24px;padding:0;margin:0;color:#909399;-ms-flex-negative:0;flex-shrink:0;line-height:1}.asr-check-template-table__header-action i[data-v-03627038]{font-size:14px}.asr-check-template-table__search-form[data-v-03627038]{padding:16px 24px 20px}.asr-check-template-table__search-grid[data-v-03627038]{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:12px 16px}.asr-check-template-table__search-actions[data-v-03627038]{margin-top:16px;padding-top:4px}.asr-check-template-table__list-body[data-v-03627038]{padding:16px}.asr-check-template-table__toolbar[data-v-03627038]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;gap:12px;padding:0 0 16px}.asr-check-template-table__table-wrap[data-v-03627038]{border:1px solid #ebeef5;border-radius:8px;overflow:hidden;margin-top:0}.asr-check-template-table__table-wrap ::v-deep .el-table[data-v-03627038]:after,.asr-check-template-table__table-wrap ::v-deep .el-table[data-v-03627038]:before{display:none}.asr-check-template-table__table-wrap ::v-deep .el-table__body tr:last-child td[data-v-03627038]{border-bottom:none}.asr-check-template-table__table ::v-deep th[data-v-03627038]{background:#f5f7fa;color:#909399;font-size:12px;font-weight:500}.asr-check-template-table__table ::v-deep td[data-v-03627038]{font-size:14px;color:#303133}.asr-check-template-table__table ::v-deep .el-table__row:hover>td[data-v-03627038]{background:#fafafa}.asr-check-template-table__actions[data-v-03627038]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:6px;padding:4px 0}.asr-check-template-table__action[data-v-03627038]{display:inline-block;padding:4px 10px;border-radius:4px;font-size:12px;line-height:18px;font-weight:500;background:#fff;cursor:pointer;-webkit-transition:background-color .15s ease;transition:background-color .15s ease;outline:none;font-family:inherit}.asr-check-template-table__action[type=button][data-v-03627038]{-webkit-appearance:none;-moz-appearance:none;appearance:none}.asr-check-template-table__action.is-edit[data-v-03627038]{color:#606266;border:1px solid #909399}.asr-check-template-table__action.is-copy[data-v-03627038]{color:#059669;border:1px solid #34d399}.asr-check-template-table__action.is-bind[data-v-03627038]{color:#2563eb;border:1px solid #3b82f6}.asr-check-template-table__action.is-delete[data-v-03627038]{color:#dc2626;border:1px solid #ef4444}.asr-check-template-table__action[data-v-03627038]:hover{background:#f9fafb}.asr-check-template-table .pagination[data-v-03627038]{margin:16px auto 0;text-align:center}@media (max-width:1200px){.asr-check-template-table__search-grid[data-v-03627038]{grid-template-columns:repeat(2,minmax(0,1fr))}}@media (max-width:768px){.asr-check-template-table__search-grid[data-v-03627038]{grid-template-columns:1fr}}", "", {"version":3,"sources":["/workspace/src/views/audio-asr-check/pages/AudioAsrCheckTemplateTable.vue"],"names":[],"mappings":"AACA,iDAAiD,gBAAgB,kBAAkB,6CAA8C,qCAAsC,eAAe,CACrL,AACD,iFAAiF,eAAe,CAC/F,AACD,wDAAwD,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,yBAAyB,sBAAsB,8BAA8B,kBAAkB,gCAAgC,eAAe,yBAAyB,sBAAsB,qBAAqB,iBAAiB,cAAc,eAAe,eAAe,CAC7b,AACD,0DAA0D,aAAa,CACtE,AACD,gEAAgE,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,OAAO,CAC7L,AACD,4HAA4H,eAAe,UAAU,QAAQ,CAC5J,AACD,0DAA0D,2BAA2B,2BAA2B,oBAAoB,yBAAyB,sBAAsB,mBAAmB,wBAAwB,qBAAqB,uBAAuB,WAAW,YAAY,UAAU,SAAS,cAAc,oBAAoB,cAAc,aAAa,CAChX,AACD,4DAA4D,cAAc,CACzE,AACD,wDAAwD,sBAAsB,CAC7E,AACD,wDAAwD,aAAa,8CAAgD,aAAa,CACjI,AACD,2DAA2D,gBAAgB,eAAe,CACzF,AACD,sDAAsD,YAAY,CACjE,AACD,oDAAoD,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,uBAAuB,oBAAoB,2BAA2B,SAAS,gBAAgB,CACzQ,AACD,uDAAuD,yBAAyB,kBAAkB,gBAAgB,YAAY,CAC7H,AACD,iKAAmK,YAAY,CAC9K,AACD,iGAAiG,kBAAkB,CAClH,AACD,8DAA8D,mBAAmB,cAAc,eAAe,eAAe,CAC5H,AACD,8DAA8D,eAAe,aAAa,CACzF,AACD,mFAAmF,kBAAkB,CACpG,AACD,oDAAoD,oBAAoB,oBAAoB,aAAa,mBAAmB,eAAe,QAAQ,aAAa,CAC/J,AACD,mDAAmD,qBAAqB,iBAAiB,kBAAkB,eAAe,iBAAiB,gBAAgB,gBAAgB,eAAe,8CAA+C,sCAAuC,aAAa,mBAAmB,CAC/S,AACD,gEAAkE,wBAAwB,qBAAqB,eAAe,CAC7H,AACD,2DAA2D,cAAc,wBAAwB,CAChG,AACD,2DAA2D,cAAc,wBAAwB,CAChG,AACD,2DAA2D,cAAc,wBAAwB,CAChG,AACD,6DAA6D,cAAc,wBAAwB,CAClG,AACD,yDAAyD,kBAAkB,CAC1E,AACD,uDAAuD,mBAAmB,iBAAiB,CAC1F,AACD,0BACA,wDAAwD,6CAA+C,CACtG,CACA,AACD,yBACA,wDAAwD,yBAAyB,CAChF,CACA","file":"AudioAsrCheckTemplateTable.vue","sourcesContent":["\n.asr-check-template-table__card[data-v-03627038]{background:#fff;border-radius:8px;-webkit-box-shadow:0 1px 3px rgba(0,0,0,0.08);box-shadow:0 1px 3px rgba(0,0,0,0.08);overflow:hidden\n}\n.asr-check-template-table__card+.asr-check-template-table__card[data-v-03627038]{margin-top:16px\n}\n.asr-check-template-table__card-header[data-v-03627038]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:12px 24px;border-bottom:1px solid #ebeef5;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;color:#606266;font-size:14px;font-weight:500\n}\n.asr-check-template-table__card-header i[data-v-03627038]{color:#909399\n}\n.asr-check-template-table__card-header-actions[data-v-03627038]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px\n}\n.asr-check-template-table__card-header-actions ::v-deep .asr-check-template-table__header-action.el-button[data-v-03627038]{min-width:24px;padding:0;margin:0\n}\n.asr-check-template-table__header-action[data-v-03627038]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:24px;height:24px;padding:0;margin:0;color:#909399;-ms-flex-negative:0;flex-shrink:0;line-height:1\n}\n.asr-check-template-table__header-action i[data-v-03627038]{font-size:14px\n}\n.asr-check-template-table__search-form[data-v-03627038]{padding:16px 24px 20px\n}\n.asr-check-template-table__search-grid[data-v-03627038]{display:grid;grid-template-columns:repeat(3, minmax(0, 1fr));gap:12px 16px\n}\n.asr-check-template-table__search-actions[data-v-03627038]{margin-top:16px;padding-top:4px\n}\n.asr-check-template-table__list-body[data-v-03627038]{padding:16px\n}\n.asr-check-template-table__toolbar[data-v-03627038]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;gap:12px;padding:0 0 16px\n}\n.asr-check-template-table__table-wrap[data-v-03627038]{border:1px solid #ebeef5;border-radius:8px;overflow:hidden;margin-top:0\n}\n.asr-check-template-table__table-wrap ::v-deep .el-table[data-v-03627038]::before,.asr-check-template-table__table-wrap ::v-deep .el-table[data-v-03627038]::after{display:none\n}\n.asr-check-template-table__table-wrap ::v-deep .el-table__body tr:last-child td[data-v-03627038]{border-bottom:none\n}\n.asr-check-template-table__table ::v-deep th[data-v-03627038]{background:#f5f7fa;color:#909399;font-size:12px;font-weight:500\n}\n.asr-check-template-table__table ::v-deep td[data-v-03627038]{font-size:14px;color:#303133\n}\n.asr-check-template-table__table ::v-deep .el-table__row:hover>td[data-v-03627038]{background:#fafafa\n}\n.asr-check-template-table__actions[data-v-03627038]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:6px;padding:4px 0\n}\n.asr-check-template-table__action[data-v-03627038]{display:inline-block;padding:4px 10px;border-radius:4px;font-size:12px;line-height:18px;font-weight:500;background:#fff;cursor:pointer;-webkit-transition:background-color 0.15s ease;transition:background-color 0.15s ease;outline:none;font-family:inherit\n}\n.asr-check-template-table__action[type='button'][data-v-03627038]{-webkit-appearance:none;-moz-appearance:none;appearance:none\n}\n.asr-check-template-table__action.is-edit[data-v-03627038]{color:#606266;border:1px solid #909399\n}\n.asr-check-template-table__action.is-copy[data-v-03627038]{color:#059669;border:1px solid #34d399\n}\n.asr-check-template-table__action.is-bind[data-v-03627038]{color:#2563eb;border:1px solid #3b82f6\n}\n.asr-check-template-table__action.is-delete[data-v-03627038]{color:#dc2626;border:1px solid #ef4444\n}\n.asr-check-template-table__action[data-v-03627038]:hover{background:#f9fafb\n}\n.asr-check-template-table .pagination[data-v-03627038]{margin:16px auto 0;text-align:center\n}\n@media (max-width: 1200px){\n.asr-check-template-table__search-grid[data-v-03627038]{grid-template-columns:repeat(2, minmax(0, 1fr))\n}\n}\n@media (max-width: 768px){\n.asr-check-template-table__search-grid[data-v-03627038]{grid-template-columns:1fr\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 3166:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3167);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("2f2f3a4c", content, true, {});

/***/ }),

/***/ 3167:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".asr-check-template-table__search-form .el-form-item{margin-bottom:0}.asr-check-template-table__search-form .el-form-item__label{color:#606266;font-size:13px;line-height:32px}", "", {"version":3,"sources":["/workspace/src/views/audio-asr-check/pages/AudioAsrCheckTemplateTable.vue"],"names":[],"mappings":"AACA,qDAAqD,eAAe,CACnE,AACD,4DAA4D,cAAc,eAAe,gBAAgB,CACxG","file":"AudioAsrCheckTemplateTable.vue","sourcesContent":["\n.asr-check-template-table__search-form .el-form-item{margin-bottom:0\n}\n.asr-check-template-table__search-form .el-form-item__label{color:#606266;font-size:13px;line-height:32px\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 3168:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AudioAsrCheckBoundSubstepDialog_vue__ = __webpack_require__(2514);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_715bda2f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AudioAsrCheckBoundSubstepDialog_vue__ = __webpack_require__(3171);
function injectStyle (ssrContext) {
  __webpack_require__(3169)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-715bda2f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AudioAsrCheckBoundSubstepDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_715bda2f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AudioAsrCheckBoundSubstepDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 3169:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3170);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("509beda2", content, true, {});

/***/ }),

/***/ 3170:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".asr-bound-substep-dialog[data-v-715bda2f]{min-height:120px}.asr-bound-substep-dialog__section+.asr-bound-substep-dialog__section[data-v-715bda2f]{margin-top:20px;padding-top:16px;border-top:1px solid #ebeef5}.asr-bound-substep-dialog__section-title[data-v-715bda2f]{margin-bottom:12px;color:#303133;font-size:14px;font-weight:500}.asr-bound-substep-dialog__empty[data-v-715bda2f]{color:#909399;font-size:14px;text-align:center;padding:16px 0}.asr-bound-substep-dialog__list[data-v-715bda2f]{margin:0;padding:0;list-style:none;max-height:280px;overflow-y:auto}.asr-bound-substep-dialog__item[data-v-715bda2f]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;gap:12px;padding:8px 4px;border-bottom:1px solid #ebeef5}.asr-bound-substep-dialog__item[data-v-715bda2f]:last-child{border-bottom:none}.asr-bound-substep-dialog__link[data-v-715bda2f]{-webkit-box-flex:1;-ms-flex:1;flex:1;min-width:0;word-break:break-all}.asr-bound-substep-dialog__unbind[data-v-715bda2f]{-ms-flex-negative:0;flex-shrink:0;padding:0;font-size:16px;color:#dc2626}.asr-bound-substep-dialog__unbind[data-v-715bda2f]:hover{color:#b91c1c}.asr-bound-substep-dialog__add[data-v-715bda2f]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:12px}.asr-bound-substep-dialog__select[data-v-715bda2f]{-webkit-box-flex:1;-ms-flex:1;flex:1;min-width:0}.asr-bound-substep-dialog__tip[data-v-715bda2f]{margin-top:8px;color:#909399;font-size:12px;line-height:1.5}", "", {"version":3,"sources":["/workspace/src/views/audio-asr-check/components/AudioAsrCheckBoundSubstepDialog.vue"],"names":[],"mappings":"AACA,2CAA2C,gBAAgB,CAC1D,AACD,uFAAuF,gBAAgB,iBAAiB,4BAA4B,CACnJ,AACD,0DAA0D,mBAAmB,cAAc,eAAe,eAAe,CACxH,AACD,kDAAkD,cAAc,eAAe,kBAAkB,cAAc,CAC9G,AACD,iDAAiD,SAAS,UAAU,gBAAgB,iBAAiB,eAAe,CACnH,AACD,iDAAiD,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,yBAAyB,sBAAsB,8BAA8B,SAAS,gBAAgB,+BAA+B,CAC5S,AACD,4DAA4D,kBAAkB,CAC7E,AACD,iDAAiD,mBAAmB,WAAW,OAAO,YAAY,oBAAoB,CACrH,AACD,mDAAmD,oBAAoB,cAAc,UAAU,eAAe,aAAa,CAC1H,AACD,yDAAyD,aAAa,CACrE,AACD,gDAAgD,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,QAAQ,CAC9K,AACD,mDAAmD,mBAAmB,WAAW,OAAO,WAAW,CAClG,AACD,gDAAgD,eAAe,cAAc,eAAe,eAAe,CAC1G","file":"AudioAsrCheckBoundSubstepDialog.vue","sourcesContent":["\n.asr-bound-substep-dialog[data-v-715bda2f]{min-height:120px\n}\n.asr-bound-substep-dialog__section+.asr-bound-substep-dialog__section[data-v-715bda2f]{margin-top:20px;padding-top:16px;border-top:1px solid #ebeef5\n}\n.asr-bound-substep-dialog__section-title[data-v-715bda2f]{margin-bottom:12px;color:#303133;font-size:14px;font-weight:500\n}\n.asr-bound-substep-dialog__empty[data-v-715bda2f]{color:#909399;font-size:14px;text-align:center;padding:16px 0\n}\n.asr-bound-substep-dialog__list[data-v-715bda2f]{margin:0;padding:0;list-style:none;max-height:280px;overflow-y:auto\n}\n.asr-bound-substep-dialog__item[data-v-715bda2f]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;gap:12px;padding:8px 4px;border-bottom:1px solid #ebeef5\n}\n.asr-bound-substep-dialog__item[data-v-715bda2f]:last-child{border-bottom:none\n}\n.asr-bound-substep-dialog__link[data-v-715bda2f]{-webkit-box-flex:1;-ms-flex:1;flex:1;min-width:0;word-break:break-all\n}\n.asr-bound-substep-dialog__unbind[data-v-715bda2f]{-ms-flex-negative:0;flex-shrink:0;padding:0;font-size:16px;color:#dc2626\n}\n.asr-bound-substep-dialog__unbind[data-v-715bda2f]:hover{color:#b91c1c\n}\n.asr-bound-substep-dialog__add[data-v-715bda2f]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:12px\n}\n.asr-bound-substep-dialog__select[data-v-715bda2f]{-webkit-box-flex:1;-ms-flex:1;flex:1;min-width:0\n}\n.asr-bound-substep-dialog__tip[data-v-715bda2f]{margin-top:8px;color:#909399;font-size:12px;line-height:1.5\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 3171:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":_vm.dialogTitle,"visible":_vm.dialogVisible,"width":"640px","append-to-body":""},on:{"update:visible":function($event){_vm.dialogVisible=$event},"open":_vm.onOpen,"close":_vm.onClose}},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"asr-bound-substep-dialog"},[_c('div',{staticClass:"asr-bound-substep-dialog__section"},[_c('div',{staticClass:"asr-bound-substep-dialog__section-title"},[_vm._v("已关联分步模板")]),_vm._v(" "),(!_vm.loading && _vm.list.length === 0)?_c('div',{staticClass:"asr-bound-substep-dialog__empty"},[_vm._v("\n        暂无关联\n      ")]):_c('ul',{staticClass:"asr-bound-substep-dialog__list"},_vm._l((_vm.list),function(item){return _c('li',{key:item.id,staticClass:"asr-bound-substep-dialog__item"},[_c('router-link',{staticClass:"asr-bound-substep-dialog__link",attrs:{"to":_vm.stepTemplatePath(item),"target":"_blank"}},[_c('el-link',{attrs:{"type":"primary"}},[_vm._v(_vm._s(_vm.formatTitleWithId(item)))])],1),_vm._v(" "),_c('el-button',{staticClass:"asr-bound-substep-dialog__unbind",attrs:{"type":"text","icon":"el-icon-delete","title":"去掉关联","loading":_vm.unbindingId === item.id},on:{"click":function($event){return _vm.onUnbind(item)}}})],1)}),0)]),_vm._v(" "),_c('div',{staticClass:"asr-bound-substep-dialog__section"},[_c('div',{staticClass:"asr-bound-substep-dialog__section-title"},[_vm._v("添加新关联")]),_vm._v(" "),_c('div',{staticClass:"asr-bound-substep-dialog__add"},[_c('remote-select',{staticClass:"asr-bound-substep-dialog__select",attrs:{"clearable":"","keyword-key":"keyword","label-key":"title","value-key":"id","id-key":"id","placeholder":"请输入分步模板关键字","query-request":_vm.getStepTemplateTable,"find-request":_vm.getStepTemplateDetail},model:{value:(_vm.addSubstepId),callback:function ($$v) {_vm.addSubstepId=$$v},expression:"addSubstepId"}}),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"small","loading":_vm.adding,"disabled":!_vm.addSubstepId},on:{"click":_vm.onAdd}},[_vm._v("\n          添加关联\n        ")])],1),_vm._v(" "),_c('div',{staticClass:"asr-bound-substep-dialog__tip"},[_vm._v("\n        一个分步模板最多关联一个录音风险配置；若已关联其他配置，添加时会提示并换绑。\n      ")])])]),_vm._v(" "),_c('span',{attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.dialogVisible = false}}},[_vm._v("关闭")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 3172:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}],staticClass:"asr-check-template-table"},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("录音风险管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("录音风险配置")])],1)],1),_vm._v(" "),_c('div',{staticClass:"asr-check-template-table__card asr-check-template-table__card--search"},[_c('div',{staticClass:"asr-check-template-table__card-header",on:{"click":function($event){_vm.searchExpanded = !_vm.searchExpanded}}},[_c('span',[_vm._v("搜索")]),_vm._v(" "),_c('i',{class:_vm.searchExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'})]),_vm._v(" "),_c('el-form',{directives:[{name:"show",rawName:"v-show",value:(_vm.searchExpanded),expression:"searchExpanded"}],ref:"searchForm",staticClass:"asr-check-template-table__search-form",attrs:{"model":_vm.search,"label-width":"96px","label-position":"left","size":"small"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSearch()}}},[_c('div',{staticClass:"asr-check-template-table__search-grid"},[_c('el-form-item',{attrs:{"label":"配置标题","prop":"title"}},[_c('el-input',{attrs:{"placeholder":"请输入配置标题","clearable":""},model:{value:(_vm.search.title),callback:function ($$v) {_vm.$set(_vm.search, "title", $$v)},expression:"search.title"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"创建人","prop":"creator_id"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","placeholder":"请输入管理员","keyword-key":"name","query-request":_vm.getBasicPlatformUsersIndex,"find-request":_vm.getPlatformUsersDetail},model:{value:(_vm.search.creator_id),callback:function ($$v) {_vm.$set(_vm.search, "creator_id", $$v)},expression:"search.creator_id"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"创建时间","prop":"created_at"}},[_c('el-date-picker',{staticClass:"width-max",attrs:{"value-format":"yyyy-MM-dd HH:mm:ss","type":"datetimerange","picker-options":_vm.dateTimePickerRangeOptions,"range-separator":"至","start-placeholder":"开始时间","end-placeholder":"结束时间","default-time":['00:00:00', '23:59:59'],"clearable":""},model:{value:(_vm.search.created_at),callback:function ($$v) {_vm.$set(_vm.search, "created_at", $$v)},expression:"search.created_at"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"asr-check-template-table__search-actions"},[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-search","native-type":"submit"}},[_vm._v("搜索")]),_vm._v(" "),_c('el-button',{attrs:{"icon":"el-icon-refresh"},on:{"click":function($event){return _vm.resetSearch()}}},[_vm._v("重置")])],1)])],1),_vm._v(" "),_c('div',{staticClass:"asr-check-template-table__card"},[_c('div',{staticClass:"asr-check-template-table__card-header",on:{"click":function($event){_vm.listExpanded = !_vm.listExpanded}}},[_c('span',[_vm._v("列表")]),_vm._v(" "),_c('div',{staticClass:"asr-check-template-table__card-header-actions"},[_c('el-button',{staticClass:"asr-check-template-table__header-action",attrs:{"type":"text","icon":"el-icon-refresh"},on:{"click":function($event){$event.stopPropagation();return _vm.onRefresh()}}}),_vm._v(" "),_c('span',{staticClass:"asr-check-template-table__header-action"},[_c('i',{class:_vm.listExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'})])],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.listExpanded),expression:"listExpanded"}],staticClass:"asr-check-template-table__list-body"},[_c('div',{staticClass:"asr-check-template-table__toolbar"},[_c('router-link',{attrs:{"to":'/audio-asr-check/template/create'}},[_c('el-button',{attrs:{"type":"primary","size":"small"}},[_vm._v("新建配置")])],1),_vm._v(" "),_c('el-button',{attrs:{"type":"success","size":"small","icon":"sj-icon-export"},on:{"click":_vm.onExportSearch}},[_vm._v("按搜索结果导出")])],1),_vm._v(" "),_c('div',{staticClass:"asr-check-template-table__table-wrap"},[_c('el-table',{staticClass:"asr-check-template-table__table",staticStyle:{"width":"100%"},attrs:{"data":_vm.table}},[_c('el-table-column',{attrs:{"prop":"id","label":"配置ID","width":"88"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"title","label":"配置标题","min-width":"200","show-overflow-tooltip":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('router-link',{attrs:{"to":("/audio-asr-check/template/update/" + (scope.row.id))}},[_c('el-link',{attrs:{"type":"primary"}},[_vm._v(_vm._s(scope.row.title || '-'))])],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"question_count","label":"问题数","width":"90"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"bind_count","label":"绑定分步模板数","width":"130","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"user_name","label":"创建人","min-width":"110","show-overflow-tooltip":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v(_vm._s(scope.row.user_name || '-'))]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"created_at","label":"创建时间","width":"170"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"updated_at","label":"更新时间","width":"170"}}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","label":"操作","width":"340","align":"left"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"asr-check-template-table__actions"},[_c('span',{staticClass:"asr-check-template-table__action is-edit",on:{"click":function($event){return _vm.$router.push(("/audio-asr-check/template/update/" + (scope.row.id)))}}},[_vm._v("\n                  "+_vm._s(Number(scope.row.editable) === 1 ? '修改' : '查看')+"\n                ")]),_vm._v(" "),_c('span',{staticClass:"asr-check-template-table__action is-copy",on:{"click":function($event){return _vm.onCopy(scope.row)}}},[_vm._v("复制")]),_vm._v(" "),_c('span',{staticClass:"asr-check-template-table__action is-bind",on:{"click":function($event){return _vm.openBoundSubstepDialog(scope.row)}}},[_vm._v("关联分步模板")]),_vm._v(" "),(_vm.canDelete(scope.row))?_c('button',{staticClass:"asr-check-template-table__action is-delete",attrs:{"type":"button"},on:{"click":function($event){return _vm.onDelete(scope.row)}}},[_vm._v("删除")]):_vm._e()])]}}])})],1)],1),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"background":"","current-page":_vm.pagination.current_page,"page-sizes":[20, 50, 100, 200],"page-size":_vm.pagination.per_page,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.pagination.total},on:{"size-change":_vm.handleSizePageChange,"current-change":_vm.handleCurrentPageChange}})],1)])]),_vm._v(" "),_c('audio-asr-check-bound-substep-dialog',{attrs:{"visible":_vm.boundSubstepDialogVisible,"template-id":_vm.boundSubstepTemplateId,"template-title":_vm.boundSubstepTemplateTitle},on:{"update:visible":function($event){_vm.boundSubstepDialogVisible=$event},"changed":function($event){return _vm.onRefresh()}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/audio-asr-check.89bf75a4bcf847b01243.js